
<style scoped lang="scss">
// https://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
.number-variator_wrapper {
  .mod-button {
    @extend .noselect;
    $size: 24px;
    $font_size: 15px;
    $symbol_color: #264435;

    // [仮] -,+の棒：containerのサイズに応じて可変
    i {
    // i.math-stick {
      $thickness: 8%;
      $size_ratio: 40%;

      position: absolute;
      left: (100% - $size_ratio)/2;
      width: $size_ratio;
      top: 50% - $thickness/2;
      height: $thickness; // 幅
      background-color: $symbol_color;
      transform-origin: center;

      &:nth-of-type(1) {
        transform: rotate(0deg);
      }
      &:nth-of-type(2) {
        transform: rotate(90deg);
      }
    }

    display: inline-block;
    text-align: center;
    vertical-align: middle;
    width: $size;
    height: $size;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
  }
  .number-container {
    @extend .noselect;
    display: inline-block;
    font-size: 1.1rem;
    width: 2.5rem;
    margin: 0 1rem;
  }
}
</style>

<template>
<div class="number-variator_wrapper">
  <div :class="buttonClassString" @click="onPressDecrement"><i/></div>
  <div class="number-container">
    <span>{{displayedValue}}</span>
  </div>
  <div :class="buttonClassString" @click="onPressIncrement"><i/><i/></div>
</div>
</template>

<script>
export default {
  name: 'numberVariator',
  components: {},
  props: {
    step: {
      default: 1,
      type: Number,
    },
    digits: {
      default: 1,
      type: Number,
    },
    value: {
      default: 0,
      type: Number,
    },
    buttonCssClass: {
      type: String,
    },
  },
  computed: {
    buttonClassString () {
      return "mod-button " + this.buttonCssClass;
    },
    displayedValue() {
      var valString = this.value.toFixed(this.digits);
      if (this.value > 0) {
        return "+" + valString
      } else {
        return valString
      }
    }
  },
  methods: {
    onPressDecrement () {
      this.fireChange(this.value - this.step);
    },
    onPressIncrement () {
      this.fireChange(this.value + this.step);
    },
    fireChange (newVal) {
      this.$emit('change', newVal);
    },
  },
  // created() {
  // },
  // mounted() {
  // },
}
</script>




// WEBPACK FOOTER //
// src/components/sub/NumberVariator.vue